import { render, staticRenderFns } from "./teamTemplate.vue?vue&type=template&id=b13d293c&scoped=true"
import script from "./teamTemplate.vue?vue&type=script&lang=js"
export * from "./teamTemplate.vue?vue&type=script&lang=js"
import style0 from "./teamTemplate.vue?vue&type=style&index=0&id=b13d293c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13d293c",
  null
  
)

export default component.exports